import axios from 'axios';

const Authtoken = 'f53eadea-a261-4cb3-bb56-dda946749f09';

const defaultOptions = {
  baseURL: 'https://frostech.in',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `${Authtoken}`,
  },
};
const instance = axios.create(defaultOptions);

export default instance;

// will remove this later. Its been used by the theme to show the notifications and chats.
// When we will do development on these modules, we will remove that.
